import withErrorWrapper from '../../../hoc/WithErrorWrapper';
import container from './SmartConsentCard.container';

export default withErrorWrapper(container);
